import { string, bool, node } from 'prop-types'
import { kuiperClassNames } from '../../utils'

const Sidebar = ({ children, className, open }) => (
  <div className={kuiperClassNames('sidebar', className, { open })}>
    {children}
  </div>
)

Sidebar.propTypes = {
  children: node,
  className: string,
  open: bool,
}

export default Sidebar
